import React, { useId, useState } from 'react'
import { ConfirmDialog } from '../../../../shared/sso-workspace/confirm-dialog'
import { serverMessage } from '../../../../shared/error/server-message'
import { useErrorLine } from '../../../../shared/error/use-error-line'
import { setDeprecated } from './packages-api'

export const DEPRECATE_MAX = 1000

// Deprecates a version with a message (1 to 1000 characters) that installers
// see. Undeprecating is a plain confirmation on the page.
export const DeprecateDialog = ({ open, packageName, channel, version, onCancel, onDone }) => {
  const id = useId()
  const [message, setMessage] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, failure, setError] = useErrorLine()
  const text = message.trim()

  const cancel = () => { setError(null); setMessage(''); onCancel() }
  const submit = async () => {
    if (busy || !text) return
    setBusy(true)
    setError(null)
    try {
      await setDeprecated(packageName, channel, version, text)
      setBusy(false)
      setMessage('')
      onDone()
    } catch (err) {
      setBusy(false)
      setError(serverMessage(err, "The version couldn't be deprecated."), err)
    }
  }

  return (
    <ConfirmDialog open={open} title={`Deprecate ${version}?`}
      body="The message is shown to anyone who installs this version, for example which version to use instead."
      confirmText="Deprecate" confirmClassName="btn sw-btn-primary" confirmDisabled={!text} busy={busy} error={error} failure={failure}
      onConfirm={submit} onCancel={cancel}>
      <div className="mb-3">
        <label className="sw-label" htmlFor={id}>Deprecation message</label>
        <textarea id={id} className="form-control" rows={3} maxLength={DEPRECATE_MAX} value={message} onChange={e => setMessage(e.target.value)} />
        <div className="sw-hint small">{message.length} of {DEPRECATE_MAX} characters</div>
      </div>
    </ConfirmDialog>
  )
}
